<template>
<div class="chapter">
<div class="inner_page">
<h1>Content</h1>
<ol>
<li><a href="#/Text/Section0003">Juggernaut of Space</a></li>
<li><span href="#/Text/Section0004" title="Link target outside of Sample">The Flame Breathers</span></li>
<li><span href="#/Text/Section0005" title="Link target outside of Sample">The Little Monsters Come</span></li>
<li><span href="#/Text/Section0006" title="Link target outside of Sample">Ordeal in Space</span></li>
</ol>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?270ff648